<div class="modelContainer alignCenter">
  <div class="">
    <button type="button" class="close cancelBtn" typeof="button" aria-label="Close" mat-dialog-close>
      Close
    </button>
  </div>
  <div class="modelTitle">
    <span *ngIf="data.displayType=='add'">Add Cleansing Rule</span>
    <span *ngIf="data.displayType=='view'">View Cleansing Rule</span>
    <span *ngIf="data.displayType=='edit'">Edit Cleansing Rule</span>
  </div>

  <div class="modelBody regularText">
    <form [formGroup]="cleansingRuleForm">
      <div *ngIf="isLoading" class="svg-loader"></div>
      <div class="form-group row mt-3">
        <div class="col-1"></div>
        <label for="dataSourceName" class="col-2 mt-2 mandatory-field no-padding"><strong>Data Source</strong></label>
        <div class="col-3">
          <select id="dataSourceId" (change)="onDataSourceSelected($event)" class="form-control select-btn" required
            formControlName="dataSourceId">
            <option *ngFor="let element of dataSource" [ngValue]="element.dataSourceId">{{element.dataSourceName}}
            </option>
          </select>
        </div>
        <label for="parameters" class="col-2 mt-2 mandatory-field"><strong>Parameter</strong></label>
        <div class="col-3">
          <input type="text" placeholder="Search Parameter" class="form-control" id="tagName" name="tagName" formControlName="tagName"
            [typeahead]="parameterList" [typeaheadOptionField]="'tagName'"
            (typeaheadOnSelect)="onTagNameSelected($event)" [typeaheadOptionsLimit]="5" autocomplete="off"
            [readonly]="data.displayType !== 'add'" tabindex="-1" />
        </div>
      </div>
    </form>
    <div class="paddingClassMainContent mb-2">
      <div *ngIf="iscleansingDataAvailable; else elseBlock">
        <div class="row">
          <div class="col-md-12 text-center" *ngIf="isLoading">
            <div class="loader"></div>
          </div>
        </div>
      </div>
      <ng-template #elseBlock>
        <div class="row mainContent"
          *ngIf="displayTable() && globalService.isNotNullObject(cleansingRuleData.cleansingRules) && cleansingRuleData.cleansingRules.length>0;">
          <div class="col-3 tblCol">
            <mat-table [dataSource]="rulesDataSource" matSort matSortActive="cleansingMethod" matSortDirection="asc"
              matSortDisableClear cdkDropList (cdkDropListDropped)="drop($event)">
              <ng-container matColumnDef="cleansingMethod">
                <mat-header-cell *matHeaderCellDef class="heading2">Rules Sequence</mat-header-cell>
                <mat-cell *matCellDef="let element let rowIndex = index" class="largeText"
                  [ngClass]="(selectedSequence==rowIndex)?'highlighted pointer':'pointer'">
                  <span class="dragIcon" cdkDragHandle></span>
                  <span>{{element.sequence}}&nbsp;&nbsp;&nbsp;</span>
                  <span
                    *ngIf="globalService.isNotNull(element.cleansingMethodModified); else displayMethodName">{{element.cleansingMethodModified}}</span>
                  <ng-template #displayMethodName>{{element.cleansingMethod}}</ng-template>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" stickybits></mat-header-row>
              <mat-row *matRowDef="let rows; columns: displayedColumns;" (click)="setSelectedSequence(rows.sequence)" (keydown)="setSelectedSequence(rows.sequence);"
                cdkDrag [cdkDragDisabled]="data.displayType == 'view'"></mat-row>
            </mat-table>
          </div>
          <div class="col-9 tblData">
            <div class="row mt-4"></div>
            <div class="row mt-4 alignLeft d-none">
              <div class="col-4"><label class="col-form-label" for="siConversion">Evaluate Selected Tag</label></div>
              <div class="col-5 display-flex">
                <label for="siConversion" name="siConversion" class="switch">
                  <input type="checkbox"
                    id="siConversion"
                    [(ngModel)]="cleansingRuleData.cleansingRules[selectedSequence].evaluateInfluencingTag"
                    [disabled]="data.displayType === 'view'" (change)="changeEvaluateTag()" />
                  <span class="slider round"></span>.
                </label>
                <span class="largeText ml-5 mt-1">Evaluate Influencing Tag</span>
                <div class="tooltip-icon iconSize" placement="right"
                  ngbTooltip="Selected tag will be cleansed by evaluating another tag. For e.g., Fix the flowrate tag as ‘0’ when the unit on/off status tag is ‘off’">
                </div>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row mt-2 alignLeft"
              *ngIf="cleansingRuleData.cleansingRules[selectedSequence].evaluateInfluencingTag">
              <div class="col-4"><label class="mandatory-field largeText" for="influencingTag">Influencing Tag</label>
              </div>
              <div class="col-5">
                <input id="influencingTag" type="text" class="form-control largeText"
                  [(ngModel)]="cleansingRuleData.cleansingRules[selectedSequence].influencingTag"
                  [typeahead]="parameterList" [typeaheadOptionField]="'tagName'" [typeaheadOptionsLimit]="5"
                  autocomplete="off" tabindex="-1" [disabled]="data.displayType === 'view'" />
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row mt-2 alignLeft">
              <div class="col-4"><label class="mandatory-field col-form-label" for="condition">Condition</label></div>
              <div class="col-5">
                <select id="condition" class="form-control select-btn largeText" required (change)="displayHideValue()"
                  [(ngModel)]="cleansingRuleData.cleansingRules[selectedSequence].condition"
                  [disabled]="data.displayType === 'view'">
                  <option>--Select--</option>
                  <option *ngFor="let element of conditionList" [ngValue]="element">
                    {{element}}
                  </option>
                </select>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row mt-2 alignLeft"
              *ngIf="!(['Non Numeric', 'Null Values', 'Insufficient Data'].includes(cleansingRuleData.cleansingRules[selectedSequence].condition))">
              <div class="col-4"><label class="mandatory-field col-form-label" for="value">Value</label></div>
              <div class="col-5">
                <input type="number" *ngIf="!displayTextFieldValue()" class="form-control largeText"
                  [(ngModel)]="cleansingRuleData.cleansingRules[selectedSequence].value"
                  [disabled]="data.displayType === 'view'" />
                <input type="text" *ngIf="displayTextFieldValue()" class="form-control largeText"
                  [(ngModel)]="cleansingRuleData.cleansingRules[selectedSequence].value"
                  [disabled]="data.displayType === 'view'" />
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row mt-2 mb-2 alignLeft">
              <div class="col-4">
                <label class="mandatory-field col-form-label" for="cleansingMethod">Cleansing Method</label>
              </div>
              <div class="col-5">
                <select id="cleansingMethod" class="form-control select-btn largeText" required
                  [(ngModel)]="cleansingRuleData.cleansingRules[selectedSequence].cleansingMethod"
                  (change)="checkDuplicateCleansingMethod(cleansingRuleData.cleansingRules[selectedSequence].cleansingMethod)"
                  [disabled]="data.displayType === 'view'">
                  <option>--Select--</option>
                  <option *ngFor="let element of cleansingRulesList" [ngValue]="element.cleansingMethod">
                    {{element.cleansingMethod}}
                  </option>
                </select>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row mb-4 alignLeft" *ngIf="displayCleansingQualifier()">
              <div class="col-4">
                <label class="mandatory-field col-form-label"
                  for="cleansingQualifier">{{getCleansingQualifierLabel()}}</label>
              </div>
              <div class="col-5">
                <div
                  *ngIf="cleansingRuleData.cleansingRules[selectedSequence].cleansingMethod!='KNN Regression'; else knnBlock">
                  <input type="text" class="form-control largeText"
                    [(ngModel)]="cleansingRuleData.cleansingRules[selectedSequence].cleansingQualifier"
                    [disabled]="data.displayType === 'view'" />
                </div>
                <ng-template #knnBlock>
                  <textarea class="form-control largeText"
                    [(ngModel)]="cleansingRuleData.cleansingRules[selectedSequence].cleansingQualifier"
                    id="cleansingQualifier" rows="3" cols="50" disabled></textarea>
                </ng-template>
              </div>
              <div class="col-3">
                <div id="knnBlock" class="mt-3"
                  *ngIf="cleansingRuleData.cleansingRules[selectedSequence].cleansingMethod=='KNN Regression' && data.displayType != 'view'">
                  <button (click)="addKnnDependantVariables()" mat-list-item class="btn"
                    [ngClass]="(globalService.isNotNull(cleansingRuleData.cleansingRules[selectedSequence].cleansingQualifier))?'action-icon-edit mat-icon action-icon-common':'actionBtn add'">
                    &nbsp;
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

    </div>
    <div class="d-flex alignCenter mb-4"
      *ngIf="displayTable() && this.cleansingRuleData && data.displayType !== 'view'">
      <button id="createBtn" type="submit" class="btn btn-primary mr-4" (click)="addNewRule()"
        [disabled]="this.cleansingRuleData.cleansingRules?.length<1 || disableAddBtn()">Add</button>
      <button id="createBtn" type="submit" class="btn btn-primary mr-4" (click)="deleteModel()"
        [disabled]="cleansingRuleData.cleansingRules?.length<2">Delete</button>
      <button id="createBtn" type="submit" class="btn btn-primary" (click)="saveCleansingRule()"
        [disabled]="this.cleansingRuleData.cleansingRules?.length<1 || disableAddBtn()">Save</button>
    </div>
  </div>
</div>